


import { Component, Vue, Ref, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import DirectCodeInputAnimations from './DirectCodeInput.animations';

const appModule = namespace('app');

@Component({
  mixins: [DirectCodeInputAnimations]
})
export default class DirectCodeInput extends Vue {
  @Ref('input') inputEl!: HTMLInputElement;

  @appModule.Getter private isMobile!: boolean;

  private arrowLoopTl!: GSAPTimeline;
  private isInput = false;
  private configCode = '';

  get linkText() {
    return this.isMobile ? this.$t('views.mobileHome.codeLink') : this.$t('components.directCode.linkFirst');
  }

  get placeholderText() {
    return this.isMobile ? this.$t('views.mobileHome.codePlaceholder') : this.$t('components.directCode.placeholder');
  }

  @Emit('focus')
  private handleFocus() {
    return;
  }

  private enableInput() {
    this.isInput = true;

    if (this.arrowLoopTl) {
      this.arrowLoopTl.kill();
    }
  }

  private addListener() {
    this.inputEl.focus();

    this.inputEl.addEventListener('keydown', this.enterPressedHandler);
  }

  private btnClicked() {
    if (this.isInput) {
      this.submitCode();
    } else {
      this.enableInput();
    }
  }

  private beforeDestroy() {
    if (this.inputEl) {
      this.inputEl.removeEventListener('keydown', this.enterPressedHandler);
    }
  }

  private enterPressedHandler(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.submitCode();
    }
  }

  private submitCode() {
    if (this.validateCode(this.configCode)) {
      this.$emit('submit-code', this.configCode);
    } else {
      this.$emit('validation-error');
    }
  }

  private validateCode(code: string) {
    if (!code || code.length !== 9) return false;

    return true;
  }
}
